// extracted by mini-css-extract-plugin
module.exports = {"checkbox-wrapper":"checkbox_checkbox-wrapper__1YXzN","checkbox":"checkbox_checkbox__22uHx","checkbox--disabled":"checkbox_checkbox--disabled__3hvSg"};